export default "__VITE_ASSET__ae90c007__"